import React from 'react';
import {connect} from 'react-redux';
import List from './List';
import Empty from './Empty';
import mapDispatch from '~/misc/mapDispatch';
import {
  getAlertLists,
} from "~/modules/alert/actions";
class AlertList extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillMount() {
    this.props.getAlertLists({
      equipment: 'all'
    })
  }
  render() {
    return (
      <div>
        <List/>
      </div>
    );
  }
}

export default connect(({alert}) => ({
  list: alert.list,
}),mapDispatch({
  getAlertLists: (props, args) => getAlertLists(args),
}))(AlertList);



// WEBPACK FOOTER //
// ./src/components/Alert/AlertList/index.js